import webfonts from 'webfonts/webfonts'
import _ from 'underscore';

const defaults= {take: 12, pageSize:6};

class FontService{
    constructor(layer){
        this.now = new Date();
        this.layer = layer;
        this.webfonts = webfonts;
        this.categories = webfonts.categories;
        this.criteria = {
            search: '',
            categories: {}
        };
        //layer.fonts = this;
        this.sync();
    }
    toggleCategory(cat) {
        this.criteria.categories[cat] = !this.criteria.categories[cat];
        this.sync();
    }
    more() {
        this.sync(this.limitTo + defaults.pageSize);
    }
    set(ff) {
        webfonts.load(ff).then(() => {
            this.layer.fontFamily(ff);
            webfonts.addRecent(ff);
        });
    }
    isCategorySelected(cat) {
        return this.criteria.categories[cat];
    }
    clearCategories() {
        this.criteria.categories = {};
        this.sync();
    }

    sync(take, offset) {
        this.limitTo = take || defaults.take;
        let anyCategories = _.some(this.criteria.categories, c=>c);
        let re = this.criteria.search ? new RegExp(this.criteria.search, 'gi') : false;
        this.results = webfonts.results.filter(f => {
            if (anyCategories && !this.isCategorySelected(f.category)) return false;
            if (re && !re.test(f.family + f.category)) return false;
            return true;
        }).slice(offset||0, this.limitTo);
        return this.results;
    }
}

export default FontService